import { MutualFundTableBodyProps, TableBodyData } from "../../investorOverview/types";
import { Box, TableCell, TableRow, Typography, useTheme } from "@mui/material";
import { SxProps, Theme } from "@mui/system";
import { toINR } from "../../../utils/utilityFunctions";
import { NonMfTransactionDetailsData, TransactionDetailsData } from "../../../redux-store/types/products";
import { useSelector } from "react-redux";
import { RootStateType } from "../../../redux-store/reducers";

export default function NonMFTransactionBody(
    {
        tableBodyData,
        tableBodyRowCustomStyles = {},
    }: {
        tableBodyData: NonMfTransactionDetailsData[];
        tableBodyRowCustomStyles: SxProps<Theme>,
    }
): JSX.Element {
    const { palette } = useTheme()

    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);

    return (
        <>
            {tableBodyData?.map((obj: TableBodyData, index: number) => (
                <TableRow
                    key={index}
                    sx={{
                        '& td': {
                            paddingTop: "15px",
                            paddingBottom: "15px",
                            borderBottom: `0.5px solid ${palette.text.secondary}B2`,
                        },
                        ...tableBodyRowCustomStyles
                    }}
                >
                    <TableCell
                        align="left"
                    >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', flexDirection: 'row' }}>

                            <Typography
                                variant="body_500"
                                sx={(theme: Theme) => ({
                                    color: theme.palette.text.primary,
                                    '&:hover': {
                                        color: theme.palette.primary[500]
                                    },
                                    lineHeight: "20px",
                                    letterSpacing: '0.02px'
                                })}
                            >
                                {obj?.customer}
                            </Typography>
                        </Box>
                    </TableCell>
                    <TableCell
                        align="center"
                    >
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {obj?.portfolio}
                        </Typography>
                    </TableCell>
                    <TableCell
                        align="center"
                    >
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {obj?.security}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {!Number.isNaN(Number(obj?.quantity)) ?
                                (Math.round(obj.quantity * 10000) / 10000).toLocaleString(locale, {
                                    useGrouping: true
                                }) : '0'}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {toINR({ value: obj?.bookCost, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >
                            {toINR({ value: obj?.grossAmount, locale, currencyCode })}
                        </Typography>
                    </TableCell>
                    {/* <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >

                            {obj?.transName}
                        </Typography>
                    </TableCell> */}
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >

                            {obj?.transName}
                        </Typography>
                    </TableCell>
                    <TableCell align="center">
                        <Typography
                            variant="body_500"
                            sx={{
                                color: palette.text.primary,
                                lineHeight: "20px",
                                letterSpacing: "0.02px"
                            }}
                        >

                            {obj?.transDate}
                        </Typography>
                    </TableCell>
                </TableRow>
            ))}
        </>
    )
}